import { useEffect, useState } from 'react';
import { MintCardSwiper } from '../../minting/MintCardSwiper';
import { MintPanels } from '../../minting/MintPanels';
import { getMintGuideOptions, MintGuideOptions } from '../../../util/game';

type MintGuideTabProps = {
  gameId: string;
};

export const MintGuideTab = ({ gameId }: MintGuideTabProps) => {
  const [mintGuideOptions, setMintGuideOptions] =
    useState<MintGuideOptions | null>(null);
  useEffect(() => {
    const handler = async () => {
      const mintOptions = await getMintGuideOptions(gameId);
      setMintGuideOptions(mintOptions);
    };
    handler();
  }, [gameId]);

  return (
    <>
      {mintGuideOptions ? (
        <>
          <MintCardSwiper mintCards={mintGuideOptions.mintCards} />
          <MintPanels
            mintDetails={mintGuideOptions.mintDetails}
            startDate={mintGuideOptions.dates.startDate}
            endDate={mintGuideOptions.dates.endDate}
            steps={mintGuideOptions.mintGuide.steps}
          />
        </>
      ) : (
        ''
      )}
    </>
  );
};
